"use client";
import { jsxs as f, jsx as m } from "react/jsx-runtime";
import { useContext as x, useRef as A, useSyncExternalStore as S, useEffect as u, createContext as v } from "react";
import { clientStore as n } from "./client-store.js";
/* empty css          */
const C = v(null);
let p = !1;
const s = {}, b = ({ children: d, initialRequest: c, configuration: i = {} }) => {
  var a;
  const e = ((a = i.spec) == null ? void 0 : a.url) || "default", l = A(null), r = S(n.subscribe, n.getSnapshot, n.getSnapshot);
  return u(() => {
    p || (async () => {
      p = !0;
      const { createApiClientModalSync: o } = await import("@scalar/api-client/layouts/Modal");
      n.setCreateClient(o);
    })();
  }, []), u(() => {
    if (!l.current || !r.createClient || s[e])
      return () => null;
    const t = r.createClient({
      el: l.current,
      configuration: i
    }), o = async () => {
      await t.updateConfig(i), c && t.route(c);
    };
    return n.addClient(e, t), s[e] = t, o(), () => {
      t.app.unmount(), n.removeClient(e), delete s[e];
    };
  }, [l.current, r.createClient]), /* @__PURE__ */ f(C.Provider, { value: r.clientDict[e], children: [
    /* @__PURE__ */ m(
      "div",
      {
        className: "scalar-app",
        ref: l
      }
    ),
    d
  ] });
}, j = () => x(C);
export {
  b as ApiClientModalProvider,
  j as useApiClientModal
};
